import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { IAuditionQuestion } from "../../../../interfaces/IAuditionQuestion";
import { IAuditionAnswer } from "../../../../interfaces/IAuditionAnswer";

const AnswerMaxLength = 144;

const QuestionAnswerSection = (props: {
  t: any;
  auditionQuestions: IAuditionQuestion[];
  auditionAnswers: IAuditionAnswer[];
  onChangeAnswer: (e: any, a: IAuditionAnswer) => void;
  pastAudition: boolean;
}) => {
  const {
    t,
    auditionQuestions,
    onChangeAnswer,
    auditionAnswers,
    pastAudition,
  } = props;

  return (
    <section style={{ marginTop: "30px" }}>
      <>
        <ContentTitle>{t("Custom Questions")}</ContentTitle>
        <form>
          {auditionQuestions.map((q, index) => {
            let a = auditionAnswers.find(
              (x) => x.auditionQuestionId === q.auditionQuestionId
            );

            if (!a) {
              a = {
                answer: "",
                auditionQuestionId: q.auditionQuestionId,
              } as IAuditionAnswer;
            }

            return (
              <div className="form-group row" key={index + 1}>
                <div className="col-12">
                  <label>{q.question ? q.question : ""}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("Begin entering answer here")}
                    maxLength={AnswerMaxLength}
                    value={a && a.answer ? a.answer : ""}
                    onChange={(e) => onChangeAnswer(e, a)}
                    disabled={pastAudition}
                  />

                  <small className="form-text text-muted float-right">{`${AnswerMaxLength} characters max`}</small>
                </div>
              </div>
            );
          })}
        </form>
      </>
    </section>
  );
};

export default withI18n()(QuestionAnswerSection);

const ContentTitle = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
  margin-bottom: 30px;
`;
